import Vue from "vue";
// import "chartist/dist/chartist.min.css";
//
// Vue.use(require("vue-chartist"));

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);
